export default "__VITE_PUBLIC_ASSET__ade2374b__"